import { render, staticRenderFns } from "./_city.vue?vue&type=template&id=6e4ee0fd&"
import script from "./_city.vue?vue&type=script&lang=js&"
export * from "./_city.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchHeader: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/search/searchHeader.vue').default,SearchBanner: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/search/searchBanner.vue').default,Results: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/search/results.vue').default})
